<template>
  <v-app>
  <v-container>
    <v-row
      justify="center"
      no-gutters
    >
    <h2 
    class="projTitle"
    data-aos="fade-up"
    data-aos-duration="1500"
    >{{title}}</h2>

      <v-col lg="10" md="10" sm="10" class="main-section"
      data-aos="fade-right"
        data-aos-duration="1500">          
          <v-carousel 
        :cycle="true"
        :interval=6000
        class="mx-auto"
        >
        <v-carousel-item
          v-for="(image,i) in images"
          :key="i"
          :src="image.src"
        ></v-carousel-item>
      </v-carousel>      
      <p class="work-desc">
        Fancy a Round was created as a <a href="http://far.alexwebb.me.uk/HowItWorks/HowItWorks.aspx" target="_blank">sporting activity portal</a> where users arrange rounds of golf. The system would then alert relevant users and allow them to request to join at the game hosts discretion.
      </p>
      <p class="work-desc">
        This was an on-going project undertaken in my personal time with continuous development. Initially written in VB.Net - it was re-written in C# with a full N-Tier design to accommodate extensibility and planned functionalities.
      </p>

<a href="http://far.alexwebb.me.uk/" target="_blank">
      <v-btn class="visit" color="primary">Visit</v-btn>
</a>
        
      </v-col>
      <v-col lg="2" md="2" sm="2" cols="auto"
      data-aos="fade-left"
        data-aos-duration="1500">
        
<v-card
          v-for="tech in technologies" :key="tech.name"
        class="tech"
        >
          <v-card-text >
            <div>{{ tech.name }}</div>
          </v-card-text>
        </v-card>

      </v-col>
    </v-row>
  </v-container>
  </v-app>
</template>

<script>
  export default {
    name: 'FARProject',
    data () {
      return {
        images: [
          {
            src: require('../assets/projects/FAR1_600x495.jpg'),
          },
          {
            src: require('../assets/projects/FAR2_600x361.jpg'),
          },
          {
            src: require('../assets/projects/FAR3_600x516.jpg'),
          },
          {
            src: require('../assets/projects/FAR4_600x505.jpg'),
          },
        ],
        technologies: [
        { name: "ASP.Net Web Forms" },
        { name: "C#" },
        { name: "ADO.Net" },        
        { name: "SQL Server" },
        { name: ".Net Membership" },
        { name: "jQuery" },
        { name: "CSS" },
        { name: "LINQ" },
        { name: "AJAX" },
        { name: "jQuery Plugins" }
    ],
    title: "Fancy a Round (Social Networking)"
      }
    },
  }
</script>
<style scoped>
.container{
  width: 100%;
  margin-bottom: 20px;
}
.text--secondary{
      text-align: left;      
}
.main-section{
  margin-bottom: 15px;
}
.text--desc{margin-bottom: 10px;}
.right{margin-left: 20px;}
.tech{
  margin-bottom: 20px;
  border-radius: 0px 50px 50px 0px!important;
  background-color: #3782d2!important;
  color: #fff!important;
}
.v-card__text{
  color: #fff!important;
  padding: 5px;
  }
.v-window-item{max-width: 100%;}
.work-desc{
  font-size: 1em;
  text-align: left;
}
h2{
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
}
  @media only screen and (max-width: 600px) {
  .tech{
  border-radius: 50px 50px 50px 50px!important;
  width: max-content;
  display: inline-block;
  margin: 5px;
  padding: 5px;
  }
  .columns{
    margin-top: 20px;
  }
}  
.visit{
    width: 100%;
  }
  .projTitle{
    margin-left: auto;
    margin-right: auto;
  }
  .v-application{
  margin-top: 0!important;
  }
  .v-application{
  margin-top: 0!important;
  }
  .row{
    border: solid 5px rgba(55,130,210, 0.2);
    border-radius: 25px;
    padding: 30px;
  }
</style>

